const vi = {
  pleaseEnterUsername: "Vui lòng nhập tên người dùng",
  cannotFriendYourself: "Bạn không thể gửi lời mời kết bạn cho chính mình.",
  friendRequestSent: "Đã gửi lời mời kết bạn!",
  failedToSendRequest: "Không thể gửi yêu cầu",
  linkCopied: "Đã sao chép liên kết vào bộ nhớ tạm!",
  backToInvites: "Quay lại lời mời",
  sendFriendRequestByUsername: "Gửi lời mời kết bạn bằng tên người dùng",
  enterUsername: "Nhập tên người dùng",
  send: "Gửi",
  yourInviteQrCode: "Mã QR mời của bạn",
  inviteLink: "Liên kết mời",
  scanQrOrUseLink: "Quét mã QR này hoặc sử dụng liên kết này để gửi lời mời kết bạn",
  copyInviteLink: "Sao chép liên kết mời",
  goToItem: "Đi tới mục",
  verificationEmailSent: "Đã gửi email xác minh! Hãy kiểm tra hộp thư đến của bạn.",
  verificationEmailFailed: "Không thể gửi email xác minh. Vui lòng thử lại.",
  verifyYourEmail: "Xác minh email của bạn",
  verifyEmailInstructions: "Vui lòng xác minh địa chỉ email của bạn để truy cập tài khoản. Kiểm tra hộp thư đến để tìm liên kết xác minh.",
  sending: "Đang gửi...",
  resendVerificationEmail: "Gửi lại email xác minh",
  login: "Đăng nhập",
  register: "Đăng ký",
  home: "Trang chủ",
  calendar: "Lịch",
  friends: "Bạn bè",
  profile: "Hồ sơ",
  logout: "Đăng xuất",
  loading: "Đang tải...",
  language: "Ngôn ngữ",
  calendarSelectPlaceSuggestion: "Vui lòng chọn một địa điểm từ gợi ý để đính kèm tọa độ.",
  calendarSelectDateAndTime: "Vui lòng chọn ngày và giờ.",
  calendarPositiveDuration: "Vui lòng nhập thời lượng dương.",
  calendarFutureDateRequired: "Ngày và giờ của sự kiện phải nằm trong tương lai.",
  calendarCreateEventFailed: "Không thể tạo sự kiện. Vui lòng thử lại.",
  cancel: "Hủy",
  createNewEvent: "Tạo sự kiện mới",
  week: "Tuần",
  month: "Tháng",
  eventTitle: "Tiêu đề",
  date: "Ngày",
  time: "Giờ",
  duration: "Thời lượng",
  endsAt: "Kết thúc lúc",
  place: "Địa điểm",
  searchForPlace: "Tìm địa điểm",
  placeSearchTip: "Mẹo: bắt đầu nhập và chọn kết quả để đính kèm tọa độ.",
  description: "Mô tả",
  createEvent: "Tạo sự kiện",
  today: "Hôm nay",
  previousMonth: "Tháng trước",
  nextMonth: "Tháng sau",
  previous: "Trước",
  next: "Tiếp",
  mondayShort: "Th 2",
  tuesdayShort: "Th 3",
  wednesdayShort: "Th 4",
  thursdayShort: "Th 5",
  fridayShort: "Th 6",
  saturdayShort: "Th 7",
  sundayShort: "CN",
  more: "thêm",
  mustRespondWillBeforeReposting: "Bạn phải chọn \"Tôi sẽ tham gia\" trước khi chia sẻ lại",
  event: "Sự kiện",
  backToCalendar: "Quay lại lịch",
  addToGoogleCalendar: "Thêm vào Google Calendar",
  when: "Khi nào",
  where: "Ở đâu",
  openLocationInGoogleMaps: "Mở vị trí trong Google Maps",
  hosts: "Người tổ chức",
  yourResponse: "Phản hồi của bạn",
  currentResponse: "Phản hồi hiện tại",
  response_will: "Tôi sẽ tham gia",
  response_might: "Có thể tôi sẽ tham gia",
  response_wont: "Tôi sẽ không tham gia",
  willRunIntoYou: "Tôi sẽ ghé qua",
  mightDropBy: "Có thể tôi sẽ ghé qua",
  wontCome: "Tôi sẽ không đến",
  repostToMyFriends: "Chia sẻ lại với bạn bè",
  responses: "Phản hồi",
  willAttend: "Sẽ tham gia",
  reposted: "Đã chia sẻ lại",
  mightAttend: "Có thể tham gia",
  cancelEvent: "Hủy sự kiện",
  cancellationEmailNoticeBefore: "Những người đã xác nhận tham gia",
  cancellationEmailNoticeAfter: "sẽ nhận được email thông báo về việc hủy sự kiện.",
  optionalCancellationMessage: "Tin nhắn tùy chọn cho người tham gia (tối đa 1000 ký tự)",
  confirmCancelEvent: "Xác nhận hủy sự kiện",
  clear: "Xóa",
  confirmCancellation: "Xác nhận hủy",
  confirmCancellationMessage: "Bạn có chắc muốn hủy sự kiện này không? Những người tham gia đã xác nhận sẽ được thông báo và sự kiện sẽ bị xóa.",
  eventCancelledNotified: "Sự kiện đã bị hủy. Đã thông báo cho",
  attendees: "người tham gia",
  failedToCancelEvent: "Không thể hủy sự kiện",
  back: "Quay lại",
  cancelled: "Đã hủy",
  ok: "OK",
  forgotPassword: "Quên mật khẩu",
  email: "Email",
  passwordResetLinkSent: "Nếu tài khoản tồn tại, một liên kết đặt lại mật khẩu đã được gửi.",
  passwordResetRequestFailed: "Không thể yêu cầu đặt lại mật khẩu.",
  sendResetLink: "Gửi liên kết đặt lại",
  addFriend: "Thêm bạn",
  incomingRequests: "Yêu cầu nhận được",
  accept: "Chấp nhận",
  deny: "Từ chối",
  myFriends: "Bạn bè của tôi",
  noFriendsYet: "Bạn chưa có bạn bè nào. Hãy bắt đầu thêm bạn bè!",
  seeProfile: "Xem hồ sơ",
  noEventsToRespondTo: "Không có sự kiện nào cần phản hồi",
  allCaughtUp: "Bạn đã cập nhật tất cả. Hãy quay lại sau để xem các sự kiện mới từ bạn bè.",
  events: "Sự kiện",
  unknown: "Không xác định",
  noDescriptionProvided: "Không có mô tả.",
  will: "Có",
  maybe: "Có thể",
  wont: "Không",
  userNotFound: "Không tìm thấy người dùng",
  friendRequestSentSuccessfully: "Đã gửi lời mời kết bạn thành công!",
  friendInvitation: "Lời mời kết bạn",
  sendFriendRequest: "Gửi lời mời kết bạn",
  loginToSendFriendRequest: "Vui lòng đăng nhập để gửi lời mời kết bạn",
  chooseLanguage: "Chọn ngôn ngữ",
  invalidCredentials: "Thông tin đăng nhập không hợp lệ. Vui lòng thử lại.",
  username: "Tên người dùng",
  password: "Mật khẩu",
  forgotPasswordQuestion: "Quên mật khẩu?",
  dontHaveAccount: "Chưa có tài khoản?",
  registerHere: "Đăng ký tại đây",
  invalidProfilePhotoType: "Loại tệp không hợp lệ. Vui lòng tải lên ảnh JPEG, PNG, GIF hoặc WebP.",
  invalidFileExtension: "Phần mở rộng tệp không hợp lệ",
  allowedExtensions: "Được phép",
  fileTooLarge: "Tệp quá lớn",
  maximumFileSize: "Tối đa",
  profilePhotoRemoved: "Đã xóa ảnh hồ sơ.",
  failedToRemoveProfilePhoto: "Không thể xóa ảnh hồ sơ",
  profileUpdatedSuccessfully: "Đã cập nhật hồ sơ thành công!",
  failedToUpdateProfile: "Không thể cập nhật hồ sơ",
  privateEmailExplanation: "Chỉ bạn mới có thể xem địa chỉ email của mình để tránh các tin nhắn không mong muốn ngoài nền tảng",
  yourEmailIsPrivate: "Email của bạn là riêng tư.",
  profilePhoto: "Ảnh hồ sơ",
  removePhoto: "Xóa ảnh",
  firstName: "Tên",
  lastName: "Họ",
  tellPeopleAboutYourself: "Giới thiệu về bản thân",
  whereToContactMe: "Cách liên hệ với tôi",
  contactInfoPlaceholder: "Instagram: myUsername\nDiscord: myDiscord",
  save: "Lưu",
  notSet: "Chưa thiết lập",
  editProfile: "Chỉnh sửa hồ sơ",
  imageToCrop: "Ảnh cần cắt",
  zoom: "Thu phóng",
  usePhoto: "Sử dụng ảnh",
  name: "Tên",
  whereToContact: "Thông tin liên hệ",
  removeFriendship: "Xóa bạn bè",
  confirmRemoveFriend: "Xác nhận xóa bạn bè",
  confirmRemoveFriendBefore: "Bạn có chắc muốn xóa",
  confirmRemoveFriendAfter: "khỏi danh sách bạn bè không?",
  friendRemoved: "Đã xóa bạn bè.",
  failedToRemoveFriend: "Không thể xóa bạn bè.",
  confirmRemove: "Xác nhận xóa",
  error: "Lỗi",
  removed: "Đã xóa",
  passwordsDoNotMatch: "Mật khẩu không khớp",
  registrationFailed: "Đăng ký thất bại. Vui lòng thử lại.",
  confirmPassword: "Xác nhận mật khẩu",
  alreadyHaveAccount: "Đã có tài khoản?",
  loginHere: "Đăng nhập tại đây",
  passwordResetSuccessfully: "Đặt lại mật khẩu thành công.",
  failedToResetPassword: "Không thể đặt lại mật khẩu.",
  resetPassword: "Đặt lại mật khẩu",
  newPassword: "Mật khẩu mới",
  confirmNewPassword: "Xác nhận mật khẩu mới",
  setNewPassword: "Đặt mật khẩu mới",
  emailVerifiedSuccessfully: "Đã xác minh email thành công!",
  emailVerificationFailed: "Xác minh thất bại. Liên kết có thể không hợp lệ hoặc đã hết hạn.",
  verifying: "Đang xác minh...",
  verified: "Đã xác minh!",
  redirectingToHome: "Đang chuyển hướng về trang chủ...",
  verificationFailed: "Xác minh thất bại",
  goToHome: "Về trang chủ",
  about: "Giới thiệu",
  aboutConceptTitle: "Ý tưởng",
  aboutCreatorIntroduction: "Xin chào, tôi là Crypt0, một người leo núi và là người tạo ra Run Into Me.",
  aboutCreatorStory: "Tôi tạo trang này vì thích giao lưu và đã dành quá nhiều thời gian để sắp xếp các buổi leo núi với người khác.",
  aboutPlanningProblem: "Tôi muốn báo cho mọi người cùng lúc biết khi nào và ở đâu tôi sẽ leo núi mà không cần lời mời chính thức.",
  aboutDeveloperSolution: "Sau đó tôi nhớ ra mình là lập trình viên và có thể tự tạo giải pháp.",
  aboutWelcome: "Chào mừng đến với Run Into Me, nơi bạn thông báo cho bạn bè về các hoạt động họ có thể tham gia mà không bị áp lực.",
  aboutCallToAction: "Hãy đăng hoạt động tiếp theo sẽ vui hơn khi làm cùng nhau tại đây!",
  aboutTutorialTitle: "Hướng dẫn",
  aboutCalendarCreateEvent: "Màn hình Lịch cũng là nơi tạo sự kiện mới.",
  aboutEventColorsIntroduction: "Màu sắc thể hiện trạng thái tham gia:",
  aboutColorGold: "Vàng",
  aboutColorGoldDescription: "Bạn tổ chức sự kiện này.",
  aboutColorGreen: "Xanh lá",
  aboutColorGreenDescription: "Bạn sẽ tham gia sự kiện.",
  aboutColorOrange: "Cam",
  aboutColorOrangeDescription: "Bạn trả lời “có thể”.",
  aboutColorBlue: "Xanh dương",
  aboutColorBlueDescription: "Bạn chưa trả lời.",
  aboutColorGray: "Xám",
  aboutColorGrayDescription: "Bạn đã từ chối lời mời.",
  aboutCalendarEventDetails: "Nhấn vào sự kiện để xem chi tiết và phản hồi.",
  aboutFriendPageTitle: "Trang Bạn bè",
  aboutFriendPageDescription: "Nhập tên người dùng hoặc gửi liên kết mời / mã QR.",
  aboutHomePageTitle: "Trang chủ",
  aboutHomePageDescription: "Xem các sự kiện sắp tới và cho biết bạn có tham gia không.",
  aboutRepostScreenTitle: "Màn hình đăng lại",
  aboutGoogleCalendarDescription: "Dùng nút này để thêm sự kiện vào Google Calendar.",
  aboutRepostDescription: "Sau khi xác nhận tham gia, bạn có thể đăng lại sự kiện cho bạn bè.",
};

export default vi;